/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported credential statuses.
 */
export enum TCCredentialStatus {
    ACTIVE = 'active',
    DISABLED = 'disabled',
}
